export default class {
  static use(router) {
    router.onError(error => {
      console.log({ error })
      console.log(error.message)

      if (error.message && /Loading chunk [\w-]+ failed\./gi.test(error.message)) {
        console.log('Lazy-loading loading failure')
        // lazy-loading / code splitting has its drawbacks, aka the files changed underneath you.

        if (router.app && router.app.$store) {
          router.app.$store.dispatch('setCodeSplitRefreshNotice', true)
        }

        // Actual Error
        // bootstrap:195 GET https://app.projectferro.com/js/chunk-46742a9b.dd6095ba.js/ net::ERR_ABORTED 404

        // Message:
        // Loading chunk chunk-46742a9b failed.
        // (error: https://app.projectferro.com/js/chunk-46742a9b.dd6095ba.js)
      } else {
        console.log('Router failed')
        if (router.app && router.app.$store) {
          router.app.$store.dispatch('setGlobalErrorAlert', {
            show: true,
            text: 'An error occurred. Please try again or contact Ferro if it continues.',
          })
        }
      }
    })
  }
}
